import React from "react";
import PropTypes from "prop-types";

import { TextInput } from "@octane/spark";

const WriteIn = ({ id, value, fieldCopy, disabled, onChange }) => {
    return (
        <TextInput
            id={id}
            label={fieldCopy.label}
            placeholder={fieldCopy.placeholder}
            value={value === 'none' ? '' : value}
            disabled={disabled}
            onChange={onChange}
        />
    );
};

WriteIn.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    fieldCopy: PropTypes.objectOf(
        PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
        })
    ),
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
};

export default WriteIn;
